module.exports = __webpack_public_path__ + "img/baby-girl.813b667e.jpeg";